<script setup>
import VClamp from "vue-clamp";
import {computed, ref} from "vue";

const props = defineProps(['value', 'rawValue', 'maxLength']);
const isClamped = ref(props.rawValue.length > props.maxLength);

const bigText = computed(() => props.rawValue.length > props.maxLength);
</script>

<template>
    <div>
        <v-clamp
            v-if="isClamped"
            autoresize :max-lines="3"
        >
            {{value}}

            <template #after="{ clamped }">
                <a v-if="clamped" class="link-normal" @click="isClamped = false"> more</a>
            </template>
        </v-clamp>

        <template v-else>
            <div v-html="rawValue"/>
            <a
                v-if="bigText"
                class="link-normal"
                @click="isClamped = true">
                less
            </a>
        </template>
    </div>
</template>

<style scoped>

</style>
